import Api from 'libs/api';
import AuthService from 'services/Auth';

class TablesApi extends Api {
  constructor(restaurantId) {
    const resId = restaurantId || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/tables`);
  }

  generate = id => {
    return this.buildQuery('post', {}, `${id}/generate`);
  };

  generateAll = () => {
    return this.buildQuery('post', {}, 'generate_uncreated');
  }

  createList = (params) => {
    return this.buildQuery('post', params, 'create_list');
  };

  destroyList = () => {
    return this.buildQuery('delete', {}, 'destroy_list');
  }
}

export default TablesApi;
